import React from 'react';
import Text from './text';


export default (obj) => {
    return <Text type="number" {...obj} />
}


// WEBPACK FOOTER //
// ./src/uis/form/number.js